import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("{{yield}}",{ moduleName: "cio/components/push-provider-config/index.hbs" })